import { LeasingGroupDto } from './LeasingGroupDto';
import {
  FinanceCalculationParamsInput,
  LeasingGroupInput as LeasingGroupInputType,
  LeasingInput as LeasingInputType,
} from '../../api/graphql/generated/schema';
import { LeasingDto } from './LeasingDto';
import { CalculationConfigDto } from '../finance/calculation/calculationConfig';

const convertToLeasingGroupInput = (leasingGroup: LeasingGroupDto): LeasingGroupInputType => {
  return {
    type: leasingGroup.type,
    items: leasingGroup.items.map((item) => {
      return {
        month: item.month,
        monthlyInstalment: item.monthlyInstalment,
        totalKmPerYear: item.totalKmPerYear,
      };
    }),
    leasingCalculationParams: convertToLeasingCalculationParamsInput(leasingGroup.leasingCalculationParams),
  };
};

const convertToLeasingCalculationParamsInput = (
  calculationParams?: Readonly<CalculationConfigDto>,
): FinanceCalculationParamsInput | undefined => {
  if (!calculationParams) return undefined;
  if (
    !calculationParams?.insuranceId ||
    !calculationParams.insurancePackageId ||
    !calculationParams.insuranceDeductible ||
    !calculationParams.insuranceWindshieldLimit
  ) {
    throw new Error('Missing required parameters for leasing calculation parameters');
  }
  return {
    productId: calculationParams.productId || '',
    insuranceId: calculationParams.insuranceId,
    insurancePackageId: calculationParams.insurancePackageId,
    insuranceDeductible: calculationParams.insuranceDeductible,
    insuranceWindshieldLimit: calculationParams.insuranceWindshieldLimit,
    automaticCalculation: calculationParams.automaticCalculation || false,
    carPriceDiscount: calculationParams.carPriceDiscount,
    contraAccount: calculationParams.contraAccount || false,
    totalModelPrice: calculationParams.totalModelPrice,
    regDateFirst: calculationParams.regDateFirst,
  };
};

export const convertToLeasingInput = (leasing: LeasingDto): LeasingInputType | undefined => {
  if (leasing.serviceId) {
    return {
      serviceId: leasing.serviceId,
      contraAccount: leasing.contraAccount,
      leasingGroups: leasing.leasingGroups.map((lg) => convertToLeasingGroupInput(lg)),
    };
  } else {
    return undefined;
  }
};
